import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProfileComponent } from './profile/profile.component';
import { ThingstodoComponent } from './thingstodo/thingstodo.component';
import { FaqComponent } from './faq/faq.component';
import { TermsAndConditionComponent } from './terms-and-condition/terms-and-condition.component';

const routes: Routes = [
  { path: 'profile', component: ProfileComponent},
  { path: 'thingstodo', component: ThingstodoComponent},
  { path: 'faq', component: FaqComponent},
  { path: 'termsNCondition',component:TermsAndConditionComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InvestorRoutingModule { }
